<template>
  <div>
    <div class="top-line" style="margin-bottom: 16px">
      <router-link id="link-navigate-back" class="link-navigate-back" to="/samples/">
        <i class="material-icons material-icon--16 no-text-decoration">keyboard_backspace</i>
        Samples
      </router-link>
    </div>

    <SampleComponent
      :id="id"
      :injectionID="iid"
      @update:injectionID="updatedInjectionID"
      @update:sampleData="updatedSampleData"
    />
  </div>
</template>

<script>
  import SampleComponent from 'components/block/SampleComponent.vue';
  import PageTitle from '@/mixins/page-title';

  export default {
    name: 'SamplePage',

    components: {
      SampleComponent,
    },

    mixins: [PageTitle],

    props: {
      id: Number,
      iid: Number,
    },

    data() {
      return {
        pageTitle: 'HPLC Cloud: Sample',
      };
    },

    methods: {
      updatedInjectionID(iid) {
        if (iid == null) {
          this.$router.push({
            name: 'sample',
            params: { id: this.id },
          });
        } else if (iid === -1) {
          this.$router.push({
            name: 'sample injection new',
            params: { id: this.id },
          });
        } else {
          this.$router.push({
            name: 'sample injection',
            params: { id: this.id, iid },
          });
        }
      },
      updatedSampleData(sd) {
        this.pageTitle = `${sd?.name}: Sample HPLC.cloud`;
      },
    },
  };
</script>
